import { IJsonQuery } from '../../../json_query';
import { getTermValue } from '../../../json_query/reducers/helpers';

export function isBlackFridayBannerVisible(jsonQuery: IJsonQuery): boolean {
  return getTermValue('is_black_friday')(jsonQuery) || false;
}
